"use client";
import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { campaignImpression } from "../../../Analytics/campaigns.js";
import { AdMetricsObserver } from "../AdMetricsObserver/index.js";
import { AdButlerAdTypesComposer } from "./AdButlerAdTypesComposer.js";
const AdButlerAd = ({
  adData,
  clientDataLoaded,
  itemType,
  AdComponent,
  externalLinkModule
}) => {
  const adButlerOnLoad = useCallback(async () => {
    if (clientDataLoaded) {
      if (adData.eligible_url) {
        navigator.sendBeacon(adData.eligible_url);
      }
      if (adData.accupixel_url) {
        navigator.sendBeacon(adData.accupixel_url);
      }
    }
  }, [adData.eligible_url, adData.accupixel_url, clientDataLoaded]);
  const adButlerOnView = useCallback(async () => {
    if (clientDataLoaded) {
      if (adData.viewable_url) {
        navigator.sendBeacon(adData.viewable_url);
      }
      campaignImpression(adData, "AdButler");
    }
  }, [adData, clientDataLoaded]);
  return /* @__PURE__ */ jsx(
    AdMetricsObserver,
    {
      intersectionThreshold: 0.5,
      observerTimeDelay: 1e3,
      onLoad: adButlerOnLoad,
      onView: adButlerOnView,
      children: itemType === "product_carousel" && AdComponent ? AdComponent : /* @__PURE__ */ jsx(
        AdButlerAdTypesComposer,
        {
          adData,
          externalLinkModule,
          itemType
        }
      )
    }
  );
};
export {
  AdButlerAd
};
